import { Component, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Language } from 'src/app/models/application-models/language';

@Component({
  selector: 'app-language-settings',
  templateUrl: './language-settings.component.html',
  styleUrls: ['./language-settings.component.css']
})
export class LanguageSettingsComponent {
  @Input() modalRef: NgbModalRef;

  languages: Language[] = [
    {
      name: "languages.en",
      code: "en",
      icon: "fi-gb"
    },
    {
      name: "languages.hu",
      code: "hu",
      icon: "fi-hu"
    },
  ];

  constructor(
    private translate: TranslateService
  ) { }

  setLanguage(language: Language){
    if(!language){
      delete localStorage.lang;
      this.translate.setDefaultLang(this.translate.getBrowserLang());
      this.translate.use(this.translate.getBrowserLang());
    } else {
      localStorage.lang = language.code;
      this.translate.setDefaultLang(language.code);
      this.translate.use(language.code);
    }
    this.close();
  }

  close(){
    this.modalRef.close();
  }
}
